export default __webpack_public_path__ + "static/media/Aviso_Importante.7b2fef2f.png";